import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Nav, NavProps } from 'react-bootstrap';

export type customLinkProps = NavProps &
  React.PropsWithChildren<{
    leftIcon?: IconProp;
    rightIcon?: IconProp;
    isBlue?: boolean;
    isAlignAtEnd?: boolean;
    eventKey?: string;
    href?: string;
    onSelect?: (selectedKey: string | null) => void;
    className?: string;
    isBlueIcon?: boolean;
    isWhiteIcon?: boolean;
    target?: string;
    isBold?: boolean;
  }>;

const Link = ({
  leftIcon,
  rightIcon,
  isBlue,
  isAlignAtEnd,
  eventKey,
  children,
  href,
  onSelect,
  isBlueIcon,
  isWhiteIcon,
  className = 'py-5',
  target,
  isBold = true,
  ...props
}: customLinkProps) => {
  return (
    <Nav {...props} className={className} onSelect={onSelect}>
      <Nav.Link eventKey={eventKey} href={href} target={target}>
        {leftIcon && (
          <span className={`left-icon ${isBlueIcon ? 'icon-color' : ''}`}>
            <FontAwesomeIcon icon={leftIcon} />
          </span>
        )}
        <span
          className={`${
            isBlue ? 'color-link nav-link-text' : 'color-default nav-link-text'
          } ${isBold ? 'fw-normal' : 'fw-light'}`}
        >
          {children}
        </span>
        {rightIcon && (
          <span className={`${isAlignAtEnd ? 'right-icon-end' : 'right-icon'} ${isWhiteIcon ? 'icon-color-white' : ''}`}>
            <FontAwesomeIcon icon={rightIcon} />
          </span>
        )}
      </Nav.Link>
    </Nav>
  );
};

export default Link;
